import { useState } from 'react';
import { contactAPI } from '../services/api';

export const useContact = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submitContact = async (contactData) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(false);
      
      await contactAPI.submitContact(contactData);
      setSuccess(true);
      return true;
    } catch (err) {
      console.error('Error submitting contact:', err);
      setError(err.response?.data?.detail || 'Failed to submit contact form');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const resetStatus = () => {
    setError(null);
    setSuccess(false);
  };

  return {
    submitContact,
    loading,
    error,
    success,
    resetStatus
  };
};